import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericSelect } from '../../components';
import { InputModelWithSource } from '../../models';
import { InputWithSource } from '../../componentTypes';
import { useContractActions } from '../../context/ContractActionContext';
import { Actions } from '../../stores/ActionStore';


const PremiumTypeInput: InputWithSource = ({ input }) => {
    const contractActions = useContractActions();

    return (
        <GenericSelect
            label={input.name}
            input={input}
            onChange={() => contractActions.dispatch(Actions.RebuildNodes)}
        />
    );
};

PremiumTypeInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(PremiumTypeInput);
